/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateStatusEnum } from './DateStatusEnum';
import {
    DateStatusEnumFromJSON,
    DateStatusEnumFromJSONTyped,
    DateStatusEnumToJSON,
    DateStatusEnumToJSONTyped,
} from './DateStatusEnum';
import type { StatusAb7Enum } from './StatusAb7Enum';
import {
    StatusAb7EnumFromJSON,
    StatusAb7EnumFromJSONTyped,
    StatusAb7EnumToJSON,
    StatusAb7EnumToJSONTyped,
} from './StatusAb7Enum';

/**
 * Lightweight serializer for Hold list view.
 * @export
 * @interface HoldList
 */
export interface HoldList {
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly id: string;
    /**
     *
     * @type {boolean}
     * @memberof HoldList
     */
    readonly canManage: boolean;
    /**
     *
     * @type {number}
     * @memberof HoldList
     */
    readonly hostTeam: number;
    /**
     *
     * @type {number}
     * @memberof HoldList
     */
    readonly showTeam: number | null;
    /**
     *
     * @type {any}
     * @memberof HoldList
     */
    bookingTerms?: any | null;
    /**
     *
     * @type {any}
     * @memberof HoldList
     */
    sharedSettlement?: any | null;
    /**
     *
     * @type {string}
     * @memberof HoldList
     */
    hostNotes?: string;
    /**
     *
     * @type {number}
     * @memberof HoldList
     */
    bookingRevision?: number;
    /**
     *
     * @type {Date}
     * @memberof HoldList
     */
    acceptedAt?: Date | null;
    /**
     * Stage for this hold
     * @type {string}
     * @memberof HoldList
     */
    stage: string;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly stageName: string;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly stageVenueName: string;
    /**
     * Date of the hold
     * @type {Date}
     * @memberof HoldList
     */
    holdDate: Date;
    /**
     * Team that placed the hold
     * @type {number}
     * @memberof HoldList
     */
    promoterTeam: number;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly promoterTeamName: string;
    /**
     * Show associated with this hold (for multi-day holds)
     * @type {string}
     * @memberof HoldList
     */
    show?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly showTitle: string | null;
    /**
     * Position in the hold queue (1 = first hold, 2 = second hold, etc.)
     * @type {number}
     * @memberof HoldList
     */
    holdPosition?: number;
    /**
     * Current status of the hold
     * 
     * * `requested` - Awaiting host acceptance
     * * `declined` - Declined by host
     * * `pending` - Pending
     * * `challenged` - Challenged
     * * `confirmed` - Confirmed
     * * `standby` - Standby
     * * `released` - Released
     * * `expired` - Expired
     * * `cancelled` - Cancelled
     * @type {StatusAb7Enum}
     * @memberof HoldList
     */
    status?: StatusAb7Enum;
    /**
     * Status of the date itself
     * 
     * * `open` - Open
     * * `held` - Held
     * * `confirmed` - Confirmed
     * * `unavailable` - Unavailable
     * @type {DateStatusEnum}
     * @memberof HoldList
     */
    dateStatus?: DateStatusEnum;
    /**
     * When this hold was challenged
     * @type {Date}
     * @memberof HoldList
     */
    challengedAt?: Date | null;
    /**
     * Team that challenged this hold
     * @type {number}
     * @memberof HoldList
     */
    challengerTeam?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly challengerTeamName: string | null;
    /**
     * Deadline to respond to challenge (typically 24-48 hours)
     * @type {Date}
     * @memberof HoldList
     */
    challengeResponseDeadline?: Date | null;
    /**
     * When this hold expires if not confirmed or challenged (14 days)
     * @type {Date}
     * @memberof HoldList
     */
    expiresAt?: Date | null;
    /**
     * Deadline for pending holds to be finalized when part of a multi-date show with confirmed dates (24 hours)
     * @type {Date}
     * @memberof HoldList
     */
    decisionDeadline?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly isExpired: string;
    /**
     * Check if this hold has initiated a challenge on higher position holds.
     * This happens when this hold's team is the challenger on another hold
     * on the same stage/date with a lower position number.
     * @type {boolean}
     * @memberof HoldList
     */
    readonly hasInitiatedChallenge: boolean;
    /**
     * 
     * @type {Date}
     * @memberof HoldList
     */
    readonly createdAt: Date;
    /**
     * Actual attendance for this specific date
     * @type {number}
     * @memberof HoldList
     */
    attendance?: number | null;
    /**
     * Total ticket sales revenue for this specific date (auto-calculated)
     * @type {string}
     * @memberof HoldList
     */
    ticketRevenue?: string | null;
    /**
     * Bar/concessions revenue for this specific date
     * @type {string}
     * @memberof HoldList
     */
    barRevenue?: string | null;
    /**
     * Other revenue (merch, parking, etc.) for this specific date
     * @type {string}
     * @memberof HoldList
     */
    otherRevenue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly totalRevenue: string;
    /**
     * 
     * @type {string}
     * @memberof HoldList
     */
    readonly netProfit: string;
    /**
     * Whether this specific date has been financially settled
     * @type {boolean}
     * @memberof HoldList
     */
    isSettled?: boolean;
}



/**
 * Check if a given object implements the HoldList interface.
 */
export function instanceOfHoldList(value: object): value is HoldList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('canManage' in value) || value['canManage'] === undefined) return false;
    if (!('hostTeam' in value) || value['hostTeam'] === undefined) return false;
    if (!('showTeam' in value) || value['showTeam'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('stageName' in value) || value['stageName'] === undefined) return false;
    if (!('stageVenueName' in value) || value['stageVenueName'] === undefined) return false;
    if (!('holdDate' in value) || value['holdDate'] === undefined) return false;
    if (!('promoterTeam' in value) || value['promoterTeam'] === undefined) return false;
    if (!('promoterTeamName' in value) || value['promoterTeamName'] === undefined) return false;
    if (!('showTitle' in value) || value['showTitle'] === undefined) return false;
    if (!('challengerTeamName' in value) || value['challengerTeamName'] === undefined) return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined) return false;
    if (!('hasInitiatedChallenge' in value) || value['hasInitiatedChallenge'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('totalRevenue' in value) || value['totalRevenue'] === undefined) return false;
    if (!('netProfit' in value) || value['netProfit'] === undefined) return false;
    return true;
}

export function HoldListFromJSON(json: any): HoldList {
    return HoldListFromJSONTyped(json, false);
}

export function HoldListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'canManage': json['can_manage'],
        'hostTeam': json['host_team'],
        'showTeam': json['show_team'],
        'bookingTerms': json['booking_terms'] == null ? undefined : json['booking_terms'],
        'sharedSettlement': json['shared_settlement'] == null ? undefined : json['shared_settlement'],
        'hostNotes': json['host_notes'] == null ? undefined : json['host_notes'],
        'bookingRevision': json['booking_revision'] == null ? undefined : json['booking_revision'],
        'acceptedAt': json['accepted_at'] == null ? undefined : (new Date(json['accepted_at'])),
        'stage': json['stage'],
        'stageName': json['stage_name'],
        'stageVenueName': json['stage_venue_name'],
        'holdDate': (new Date(json['hold_date'])),
        'promoterTeam': json['promoter_team'],
        'promoterTeamName': json['promoter_team_name'],
        'show': json['show'] == null ? undefined : json['show'],
        'showTitle': json['show_title'],
        'holdPosition': json['hold_position'] == null ? undefined : json['hold_position'],
        'status': json['status'] == null ? undefined : StatusAb7EnumFromJSON(json['status']),
        'dateStatus': json['date_status'] == null ? undefined : DateStatusEnumFromJSON(json['date_status']),
        'challengedAt': json['challenged_at'] == null ? undefined : (new Date(json['challenged_at'])),
        'challengerTeam': json['challenger_team'] == null ? undefined : json['challenger_team'],
        'challengerTeamName': json['challenger_team_name'],
        'challengeResponseDeadline': json['challenge_response_deadline'] == null ? undefined : (new Date(json['challenge_response_deadline'])),
        'expiresAt': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'decisionDeadline': json['decision_deadline'] == null ? undefined : (new Date(json['decision_deadline'])),
        'isExpired': json['is_expired'],
        'hasInitiatedChallenge': json['has_initiated_challenge'],
        'createdAt': (new Date(json['created_at'])),
        'attendance': json['attendance'] == null ? undefined : json['attendance'],
        'ticketRevenue': json['ticket_revenue'] == null ? undefined : json['ticket_revenue'],
        'barRevenue': json['bar_revenue'] == null ? undefined : json['bar_revenue'],
        'otherRevenue': json['other_revenue'] == null ? undefined : json['other_revenue'],
        'totalRevenue': json['total_revenue'],
        'netProfit': json['net_profit'],
        'isSettled': json['is_settled'] == null ? undefined : json['is_settled'],
    };
}

  export function HoldListToJSON(json: any): HoldList {
      return HoldListToJSONTyped(json, false);
  }

  export function HoldListToJSONTyped(value?: Omit<HoldList, 'id'|'can_manage'|'host_team'|'show_team'|'stage_name'|'stage_venue_name'|'promoter_team_name'|'show_title'|'challenger_team_name'|'is_expired'|'has_initiated_challenge'|'created_at'|'total_revenue'|'net_profit'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_terms': value['bookingTerms'],
        'shared_settlement': value['sharedSettlement'],
        'host_notes': value['hostNotes'],
        'booking_revision': value['bookingRevision'],
        'accepted_at': value['acceptedAt'] == null ? undefined : ((value['acceptedAt'] as any).toISOString()),
        'stage': value['stage'],
        'hold_date': ((value['holdDate']).toISOString().substring(0,10)),
        'promoter_team': value['promoterTeam'],
        'show': value['show'],
        'hold_position': value['holdPosition'],
        'status': StatusAb7EnumToJSON(value['status']),
        'date_status': DateStatusEnumToJSON(value['dateStatus']),
        'challenged_at': value['challengedAt'] == null ? undefined : ((value['challengedAt'] as any).toISOString()),
        'challenger_team': value['challengerTeam'],
        'challenge_response_deadline': value['challengeResponseDeadline'] == null ? undefined : ((value['challengeResponseDeadline'] as any).toISOString()),
        'expires_at': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
        'decision_deadline': value['decisionDeadline'] == null ? undefined : ((value['decisionDeadline'] as any).toISOString()),
        'attendance': value['attendance'],
        'ticket_revenue': value['ticketRevenue'],
        'bar_revenue': value['barRevenue'],
        'other_revenue': value['otherRevenue'],
        'is_settled': value['isSettled'],
    };
}
